export interface NavItem {
  title: string;
  href: string;
}

export const navItems: NavItem[] = [
  { title: "Our Model", href: "#model" },
  { title: "Key Pillars", href: "#pillars" },
  { title: "Design", href: "#design" },
  { title: "Partners", href: "#where" },
  { title: "FAQ", href: "#faqs" },
  { title: "Team", href: "#people" },
];

export const appConfig = {
  companyName: "Trendmap",
  companySlogan: "Be Creative, Cut Waste & Embrace Speed",
};
